export default __webpack_public_path__ + "static/media/manutencao_mob.b4df2c3e.png";